module.exports = __webpack_public_path__ + "static/media/advice.f7a04150.png";